export const SLUG_API_URL = `${process.env.REACT_APP_PUBLIC_API_URL}/validate`;
export const CARDINAL_URL = `${process.env.REACT_APP_PUBLIC_CARDINAL_URL}`;
export const BASE_API_URL = `${process.env.REACT_APP_PUBLIC_API_URL}`;
export const BASE_PUBLIC_API_URL = `${process.env.REACT_APP_PUBLIC_IFRAME_API_URL}`;

/*export const PAYNOW_QR = {
  GENERATE: "paynow/generate-qr",
  GET_TRANSACTION_STATUS: "paynow/get-transaction-status/:transactionId",
};*/

/*export const QRPH_QR = {
  GENERATE: "qrph/generate-qr",
  GET_TRANSACTION_STATUS: "qrph/get-transaction-status/:transactionId",
};*/




export const DYNAMIC_QR = {
  GENERATE: "generate-qr",
  GET_TRANSACTION_STATUS: "get-transaction-status/:transactionId",
};